import { IconComponent } from '@backstage/core-plugin-api';
import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import {
  TECHDOCS_ANNOTATION,
  TECHDOCS_EXTERNAL_ANNOTATION,
} from '@backstage/plugin-techdocs-common';
import { buildTechDocsURL } from '@backstage/plugin-techdocs-react';

type ViewTechDocsLink = (args: {
  namespace: string;
  kind: string;
  name: string;
}) => string;

export const hasTechdocsAnnotation = (
  template: TemplateEntityV1beta3,
): boolean =>
  Boolean(
    template.metadata.annotations?.[TECHDOCS_ANNOTATION] ||
      template.metadata.annotations?.[TECHDOCS_EXTERNAL_ANNOTATION],
  );

export const buildTechdocsTemplateLinks = (
  template: TemplateEntityV1beta3,
  options: {
    viewTechDocsLink?: ViewTechDocsLink;
    docsIcon: IconComponent;
    linkTitle: string;
  },
): { icon: IconComponent; text: string; url: string }[] => {
  const { viewTechDocsLink, docsIcon, linkTitle } = options;

  if (!hasTechdocsAnnotation(template) || !viewTechDocsLink) {
    return [];
  }

  const url = buildTechDocsURL(template, viewTechDocsLink);
  if (!url) {
    return [];
  }

  return [{ icon: docsIcon, text: linkTitle, url }];
};
